import usePlanFlow from "@/hooks/usePlanFlow";
import {useAgencyId, useIsAdmin, useIsAgency, useIsLoggedIn, useSelectedCompanyId} from "@/hooks/useUserHooks";
import {memo, type FC} from "react";
import {Navigate, Outlet, useLocation} from "react-router";

const RequireAuth: FC<{redirectTo?: string}> = ({redirectTo}) => {
  const location = useLocation();
  const isLoggedIn = useIsLoggedIn();
  const flowState = usePlanFlow();
  const isAdmin = useIsAdmin();
  const isAgency = useIsAgency();
  const companyId = useSelectedCompanyId();
  const agencyId = useAgencyId();

  if (!isLoggedIn) {
    return (
      <Navigate
        to={redirectTo ?? "/login/"}
        replace
        state={{
          from: {...location, pathname: location.pathname + location.search},
        }}
      />
    );
  }

  if (isAdmin && location.pathname === "/") {
    return <Navigate to="/campaigns/" replace />;
  }

  if (isAgency && location.pathname === "/") {
    return <Navigate to={`/agency/${agencyId}/dashboard/`} replace />;
  }

  if (!isAdmin && location.pathname === "/" && companyId) {
    return (
      <Navigate
        to={
          flowState === "NO_PLAN_NO_CAMPAIGN" || flowState === "HAS_PLAN_NO_CAMPAIGN"
            ? "/welcome/"
            : `/company/${companyId}/dashboard/`
        }
        replace
      />
    );
  }

  return <Outlet />;
};

export default memo(RequireAuth);
